import { ViteReactSSG } from "vite-react-ssg";
import App from "./App.tsx";
import "./index.css";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound"; 
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import FAQ from "./pages/FAQ";

export const routes = [
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Index /> },
      { path: "privacy", element: <PrivacyPolicy /> },
      { path: "terms", element: <TermsOfService /> },
      { path: "faq", element: <FAQ /> },
      { path: "*", element: <NotFound /> }
    ]
  }
];

export const createRoot = ViteReactSSG({ routes });
